import { render, staticRenderFns } from "./AvexCoachesQuery.vue?vue&type=template&id=f8985cc0&lang=pug"
import script from "./AvexCoachesQuery.vue?vue&type=script&lang=js"
export * from "./AvexCoachesQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports